export const CHECKOUT_URL = 'https://ordenfinanciero.impultienda.ar/checkout'
